import React from 'react';
import _ from 'lodash';
import { dataHooks } from './constants';
import ItemRowBase from './itemRowBase';
import TextEdit from './textEdit';
import ContextMenu from '../contextMenu';
import TooltipOnEllipsis from '../tooltipOnEllipsis';

function onMouseDown1(e) {
  e.stopPropagation();
}

export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.getRowClasses(),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    onMouseEnter: this.onHover
  }, /*#__PURE__*/React.createElement(ItemRowBase, {
    dragHandle: this.shouldShowDragHandle(),
    isDefault: this.props.isDefault,
    dragHandleEnabled: this.props.dragHandleEnabled,
    isDragging: this.props.isDragging,
    dragHandleTooltipContent: this.props.dragHandleTooltipContent
  }, this.isEditMode() ? null : /*#__PURE__*/React.createElement("div", {
    className: this.getViewModeClasses(),
    key: "labelContainer",
    onMouseUp: this.select
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-container",
    onDoubleClick: this.onDoubleClick
  }, this.props.value.content || this.props.contentBefore ? /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.contentBefore,
    className: this.getContentBeforeClasses(),
    key: "contentBefore"
  }, this.props.value.content || this.props.contentBefore) : null, this.props.value.label ? /*#__PURE__*/React.createElement("div", {
    className: "text-inner-content",
    key: "label-value",
    style: {
      width: this.getTextWidth()
    }
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, null, /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.itemLabel,
    className: _(this.getLabelClasses()).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' ')
  }, this.getLabelToDisplay())), this.hasValue() && this.isMultiline() ? /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.itemValue,
    className: _(this.getValueClasses()).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' '),
    key: "value"
  }, this.getValueToDisplay()) : null, this.hasValue() && !this.isMultiline() ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    key: "valueWithEllipsis"
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.itemValue,
    className: _(this.getValueClasses()).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' ')
  }, this.getValueToDisplay())) : null) : null, this.props.contentAfter ? /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.contentAfter,
    className: "content-after",
    key: "contentAfter"
  }, this.props.contentAfter) : null), /*#__PURE__*/React.createElement("div", {
    className: "item-row-action-container",
    onMouseDown: onMouseDown1.bind(this)
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-row-action-wrapper"
  }, this.props.customAction || (this.hasContextMenu() ? /*#__PURE__*/React.createElement(ContextMenu, {
    dataHook: dataHooks.actionsMenu,
    className: "flat",
    optionsContainerClassName: 'sbdl-item-row-context-menu',
    isOpen: this.props.isContextMenuOpen,
    onToggle: this.props.onContextMenuToggle,
    direction: this.props.contextMenuDirection,
    alignment: this.props.contextMenuAlignment,
    key: "sbdlContextMenu"
  }, this.getAllContextMenuActions()) : null)))), this.editLabelMode() ? /*#__PURE__*/React.createElement(TextEdit, {
    className: "text-edit-container label-text-edit",
    key: "sbdlLabelTextEdit",
    keyboardShortcuts: true,
    autoFocus: true,
    value: this.props.value.label,
    placeholder: this.getLabelPlaceHolder(),
    maxLength: this.getLabelMaxLength(),
    validators: this.props.labelValidators,
    shouldTranslateInvalidMessage: this.props.shouldTranslateInvalidLabelMessage,
    onChange: this.updateLabelAndCloseEditMode,
    cancel: this.closeEditLabelMode,
    buttonText: this.props.submitEditLabelButtonText
  }) : null, this.editValueMode() ? /*#__PURE__*/React.createElement(TextEdit, {
    className: "text-edit-container value-text-edit",
    key: "sbdlValueTextEdit",
    keyboardShortcuts: true,
    autoFocus: true,
    value: this.props.value.value,
    placeholder: this.getValuePlaceHolder(),
    maxLength: this.getValueMaxLength(),
    validators: this.props.valueValidators,
    shouldTranslateInvalidMessage: this.props.shouldTranslateInvalidValueMessage,
    onChange: this.updateValueAndCloseEditMode,
    cancel: this.closeEditValueMode,
    buttonText: this.props.submitEditValueButtonText
  }) : null));
}